import React, { createContext, Dispatch, Reducer, useEffect, useReducer } from 'react';
import { BulkActionsState } from '../../../models/bulk-actions';
import { InitialBulkActions } from './initial';
import { MandatoryChildren } from '../../../models/children-props';
import { BulkActionsReducer } from './BulkActionsReducer';
import { BulkDispatchAction } from './BulkDispatchActions';
import { SocialProfileWithBoardsAndMentionType } from '../helpers/mapSelectedProfilesValues';
import { MappedCategoriesType } from '../../Publish/Categories/Categories.helpers';
import { GetLinkMetadataQuery, PostQueuePosition, UtmInput } from '../../../models/graphql';

type BulkActionsContextType = {
  state: BulkActionsState;
  dispatch: Dispatch<BulkDispatchAction>;
  profiles: SocialProfileWithBoardsAndMentionType[];
  categories: MappedCategoriesType[];
  utm: UtmInput;
  evergreenSettings: boolean;
  positionInQueueSettings: PostQueuePosition;
  linksMetadata: GetLinkMetadataQuery['linkMetadata'];
};
export const BulkActionsContext = createContext<BulkActionsContextType>({
  state: InitialBulkActions(),
  dispatch: () => {
    // initial
  },
  profiles: [],
  categories: [],
  utm: {
    source: '',
    medium: '',
    campaign: '',
    term: '',
    content: ''
  },
  positionInQueueSettings: PostQueuePosition.TOP,
  evergreenSettings: false,
  linksMetadata: []
});

export type BulkImportProviderProps = {
  initialState?: BulkActionsState;
  profiles: SocialProfileWithBoardsAndMentionType[];
  categories: MappedCategoriesType[];
  utm: UtmInput;
  evergreenSettings: boolean;
  positionInQueueSettings: PostQueuePosition;
  linksMetadata: GetLinkMetadataQuery['linkMetadata'];
};
export const BulkActionsProvider = ({
  children,
  initialState,
  profiles,
  categories,
  utm,
  evergreenSettings,
  positionInQueueSettings,
  linksMetadata
}: MandatoryChildren<BulkImportProviderProps>) => {
  const [state, dispatch] = useReducer<Reducer<BulkActionsState, BulkDispatchAction>>(
    BulkActionsReducer,
    initialState || InitialBulkActions()
  );

  useEffect(() => {
    dispatch({
      type: 'setEvergreen',
      payload: evergreenSettings
    });
  }, [evergreenSettings]);

  useEffect(() => {
    dispatch({
      type: 'setPositionInQueue',
      payload: positionInQueueSettings
    });
  }, [positionInQueueSettings]);

  return (
    <BulkActionsContext.Provider
      value={{ state, dispatch, profiles, categories, utm, positionInQueueSettings, evergreenSettings, linksMetadata }}>
      {children}
    </BulkActionsContext.Provider>
  );
};
